module.exports = __webpack_public_path__ + "img/brasswiesn.515881b0.png";